/**
 * Password strength rules — mirror StrongPasswordValidator (BE):
 * min 10 chars + at least 3 of 4 categories (upper, lower, digit, symbol).
 */

export const PASSWORD_SYMBOLS = "!@#$%^&*()_+-=[]{}|;:'\",.<>?/";

export interface PasswordStrength {
  minLength: boolean;
  upper: boolean;
  lower: boolean;
  digit: boolean;
  symbol: boolean;
  /** At least 3 of the 4 character categories. */
  categoriesOk: boolean;
  categoriesMet: number;
  isValid: boolean;
}

export function evaluatePasswordStrength(password: string): PasswordStrength {
  const value = password ?? '';
  const minLength = value.length >= 10;
  const upper = /[A-Z]/.test(value);
  const lower = /[a-z]/.test(value);
  const digit = /\d/.test(value);
  const symbol = [...value].some((ch) => PASSWORD_SYMBOLS.includes(ch));
  const categoriesMet = [upper, lower, digit, symbol].filter(Boolean).length;
  const categoriesOk = categoriesMet >= 3;
  return {
    minLength,
    upper,
    lower,
    digit,
    symbol,
    categoriesOk,
    categoriesMet,
    isValid: minLength && categoriesOk,
  };
}

export interface PasswordCriterion {
  key: string;
  label: string;
  ok: boolean;
}

/** Checklist items shown to the user (failed ones highlighted). */
export function passwordCriteriaList(strength: PasswordStrength): PasswordCriterion[] {
  return [
    { key: 'minLength', label: 'Almeno 10 caratteri', ok: strength.minLength },
    {
      key: 'categories',
      label: `Almeno 3 tra: maiuscole, minuscole, cifre, simboli (ora ${strength.categoriesMet}/4)`,
      ok: strength.categoriesOk,
    },
    { key: 'upper', label: 'Almeno una maiuscola (A–Z)', ok: strength.upper },
    { key: 'lower', label: 'Almeno una minuscola (a–z)', ok: strength.lower },
    { key: 'digit', label: 'Almeno una cifra (0–9)', ok: strength.digit },
    { key: 'symbol', label: `Almeno un simbolo (${PASSWORD_SYMBOLS.slice(0, 12)}…)`, ok: strength.symbol },
  ];
}
